const API_CONFIG = {
    baseURL: process.env.REACT_APP_API_URL,
    token: process.env.REACT_APP_API_TOKEN,
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
};

export const getApiUrl = (endpoint) => {
    return `${API_CONFIG.baseURL}/api/${endpoint}`;
};

export const getHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'X-API-Key': API_CONFIG.token
    };
};

export const fetchApi = async (endpoint, options = {}) => {
    const url = getApiUrl(endpoint);
    const headers = getHeaders();

    console.log('Fetching URL:', url);
    console.log('Headers:', headers);
    console.log('API Config:', API_CONFIG);

    try {
        const response = await fetch(url, {
            method: 'GET',
            ...options,
            headers: headers
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('API Error Response:', errorText);
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error details:', error);
        throw error;
    }
};

export default API_CONFIG; 